// export const basicURL = "https://core-dev.microlab.help/api/";
export const basicURL = "https://core.microlab.help/api/";
// export const basicURL = "http://localhost:4000/api/";

export const loginURL = "auth/login";
export const authURL = "auth";
export const userURL = "user/all";
export const getTitleURL = "title/json";
export const getPackageURL = "payment/package";
export const getTransactionsURL = "payment/transaction";
export const addTitleURL = "title/title";
export const addSubTitleURL = "title/sub_title";
export const addSlideURL = "title/slide";
export const addSlideFileURL = "file/upload";
export const deleteSlideFileURL = "file";
export const getSlideByIdURL = "title/getSlideById";
export const addPinURL = "title/pin";
export const editPinURL = "title/pin";
export const deletePinURL = "title/pin";
export const swapTitleURL = "title/swapTitleOrder";

export const quizTitleURL = "quiz/title";
export const quizContentURL = "quiz/content";
export const pushURL = "notification";
export const editTitleImageCallURL = "title/updateTitleImage";
export const getVerifyUserPurchaseURL = "payment/verify_user_purchase";
export const getVerifyUserAddedManuallyPurchaseURL = "payment/verify_user_purchase_added_manually";
// export const contentRandom = "quiz/contentRandom";
